<template>
  <div class="approval-config-table">
    <b-table
      :items="items"
      :fields="fields"
      bordered
      hover
      :busy="loading"
    >
      <template v-slot:table-busy>
        <vcl-table :speed="5" :animate="true" :columns="10"></vcl-table>
      </template>
      
      <template v-slot:cell(statusName)="row">
        <status-badge
          :status="row.item.status"
          :label="row.item.statusName"
        />
      </template>
      
      <template v-slot:cell(createdByName)="row">
        <p class="text-center">{{ row.item.createdByName }}</p>
        <p class="text-center">{{ row.item.createdAt }}</p>
      </template>
      
      <template v-slot:cell(actions)="row">
        <div class="d-flex justify-content-center">
          <b-dropdown size="sm" id="dropdown-left" no-caret right>
            <template slot="button-content">
              <i
                class="flaticon2-settings action-icon"
              ></i>
            </template>
            
            <b-dropdown-item
              @click="$emit('view', row.item)"
              v-if="!hasUpdatePermission"
            >
              <span class="dropdown-item-text">
                <i class="flaticon-eye"></i>
                &nbsp; Chi tiết
              </span>
            </b-dropdown-item>
            
            <b-dropdown-item
              @click="$emit('edit', row.item)"
              v-if="hasUpdatePermission"
            >
              <span class="dropdown-item-text">
                <i class="flaticon2-pen"></i>
                &nbsp; Chỉnh sửa
              </span>
            </b-dropdown-item>
            
            <!-- Delete action -->
            <b-dropdown-item
              @click="$emit('delete', row.item)"
              v-if="hasDeletePermission"
            >
              <span class="dropdown-item-text">
                <i class="delete-icon flaticon2-rubbish-bin-delete-button"></i>
                &nbsp; Xóa
              </span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import { VclTable } from 'vue-content-loading';
import StatusBadge from './StatusBadge.vue';

export default {
  name: 'ApprovalConfigTable',
  components: {
    VclTable,
    StatusBadge
  },
  props: {
    /**
     * Items to display in the table
     */
    items: {
      type: Array,
      required: true
    },
    /**
     * Loading state
     */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * Whether the user has update permission
     */
    hasUpdatePermission: {
      type: Boolean,
      default: false
    },
    /**
     * Whether the user has delete permission
     */
    hasDeletePermission: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fields: [
        {
          key: 'count',
          label: 'STT',
          thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
          tdClass: 'text-center',
        },
        {
          key: 'name',
          label: 'Tên cấu hình',
          thStyle: { fontWeight: 600, color: '#181c32', width: '30%' },
        },
        {
          key: 'approvalTypeName',
          label: 'Loại chi',
          thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
        },
        {
          key: 'statusName',
          label: 'Trạng thái',
          thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
          tdClass: 'text-center',
        },
        {
          key: 'createdByName',
          label: 'Người tạo',
          thStyle: { fontWeight: 600, color: '#181c32', width: '25%' },
        },
        {
          key: 'actions',
          label: '',
        },
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.approval-config-table {
  .action-icon {
    font-size: 1rem;
    padding-right: 0px;
  }
  
  .delete-icon {
    font-size: 1rem;
    color: #d33;
  }
  
  .dropdown-item-text {
    font-size: 12px;
    color: #3f4254;
  }
}
</style>
